<template>
  <div class="DialogReportPaid__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">החלפת טקסט לשאלות</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section style="height: 500px" class="modal-card-body">
        <div class="DialogReportPaid__Component__Loading">
          <b-field label="טקסט לחיפוש">
            <b-input v-model="searchText"></b-input>
          </b-field>
          <b-field label="טקסט להחלפה">
            <b-input v-model="replaceText"></b-input>
          </b-field>
          <!-- <b-field label="בחר יחידות לימוד">
            <v-select dir="rtl" label="Text" v-model="lessonIds" :options="lessons" :clearable="true" :multiple="true"
              :searchable="true" :close-on-select="false" :placeholder="'בחר ערך מהרשימה'">
              <div slot="no-options">לא נמצאו ערכים דומים</div>
            </v-select>
          </b-field> -->
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="isLoading" :disabled="!isValid" @click="save" label="שמור" type="is-primary" />
        <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import CoursesService from "@/services/CoursesService";
import AdminService from "@/services/AdminService";
import { DialogProgrammatic as Dialog, ToastProgrammatic as Toast } from "buefy";
import vSelect from "vue-select";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "ChangeTextToQuestions",
  props: ["questions", "onSuccess", "store"],
  components: {
    vSelect,
  },
  computed: {
    isValid() {
      return this.searchText && this.replaceText;
    },
  },
  created() {
    // this.getLessons();
  },
  data() {
    return {
      isLoading: false,
      lessonIds: null,
      lessons: [],
      searchText: null,
      replaceText: null
    };
  },
  methods: {
    getLessons() {
      CoursesService.getCourse(this.courseId,
        {
          PageSize: 9999,
          IsAscending: false,
          PageNumber: 1,
          ResultType: 3
        },
        false).then((r) => this.lessons = r.data.items.map((u) => ({
          Value: u.id,
          Text: `${u.id} - ${u.name} - ${this.getLessonTypeName(u.lessonType)}`
        }))
        );
    },
    getLessonTypeName(type) {
      switch (type) {
        case 0:
          return 'תרגול';
        case 1:
          return 'וידאו';
        case 2:
          return 'סימולציה';
        case 3:
          return 'חוק';
        case 4:
          return 'פסיקה';
        case 5:
          return 'ספרים';
        case 6:
          return 'דיוני';
        case 7:
          return 'מהותי';
        case 8:
          return 'דלתא';
        case 9:
          return 'אינטרוולים';
        case 10:
          return 'מיומנות';
        case 11:
          return 'מקוצרת';
        case 12:
          return 'ניסוח';
        case 13:
          return 'מפגשים';

        default:
          return 'תרגול';
      }
    },
    save() {
      if (this.isValid) {
        this.isLoading = true;
        AdminService.changeTextToQuestions({
          questionIds: this.questions,
          SearchText: this.searchText,
          ReplaceText: this.replaceText
        }).then(() => {
          Dialog.confirm({
            message: `
                                <div style="max-height:300px">
                                <div class="changed__text_container" style="font-weight: bold">לשאלות: <span style="font-weight: bold">${this.questions.map((q) => `${q}`)}</span></div>
                                <div>השתנה המלל</div>
                                <div>מ: ${this.searchText}</div>
                                <div>ל: ${this.replaceText}</div>
                                </div>`,
            onConfirm: () => {
              this.$emit("close");
              this.onSuccess();
            },
            confirmText: 'אישור',
            canCancel: false
          });
        }).catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה, יש לפנות לתמיכה הטכנית.",
            duration: 8000,
          });
        })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.datetime .dropdown-content {
  width: 25%;

  .field-body .field {
    flex-direction: row-reverse;
  }
}
.changed__text_container {
  margin-bottom: 15px;
  font-weight: bold;
  max-height: 209px;
  width: 361px;
  word-wrap: break-word;
  overflow: auto;
}
</style>
